import { Alert, Box, Grid, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import { Btn1, Btn2, HeadingText } from '../StyledComponents'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import DownloadIcon from '@mui/icons-material/Download';
import { useTheme } from '@emotion/react';
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
// import theme from '../Theme';

function About() {

    const [downloadStatus, setDownloadStatus] = React.useState('Resume');

    const [openStatus, setOpenStatus] = React.useState(false);
    const [statusMessage, setStatusMessage] = React.useState("");



    const handleDownload = async () => {
        if(downloadStatus=="Downloaded")
            return;
        try {
          setDownloadStatus('downloading...');
          const response = await fetch('/resume.pdf');
    
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
    
          const blob = await response.blob();
          console.log(blob)
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'resume.pdf'; 
          link.click();
          
          setDownloadStatus('Downloaded'); 
          setStatusMessage('Download complete! Thank you for your support.');
        } catch (error) {
          setDownloadStatus('error');
          setStatusMessage('Oops! We encountered an issue with the download. Please try again later.');
        } finally {
           setOpenStatus(true);
        }
      };

      

      const closeStatus = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
    
        setOpenStatus(false);
      };



    let theme=useTheme();
    let details=[
        {property:"Name",value:"Sharief"},
        {property:"Date of Birth",value:"June 23, 2001"},
        {property:"Address",value:"Kadapa,AndhraPradesh"},
        {property:"PIN Code",value:"516213"},
        {property:"Email",value:"Kadapasharief786@gmail.com"},
        {property:"Phone",value:"7989738066"},

    ]

  return (
    <Box id="aboutMe" my={10} >
        <HeadingText text="About Me" my={5} variant='h1' data-aos="fade-up" data-aos-duration="2000">
            About Me
        </HeadingText>
        <Grid container>
            <Grid item xs={12} sm={12} md={6} sx={{display:{xs:"none",sm:"none",md:"block"},}}>
                <Box sx={{width:"560px",height:"100%",display:"flex",justifyContent:"center",alignItems:"center"}}>
                    <img 
                        src='./images/myImage5.png' 
                        style={{
                            transform:"scale(1.7)",
                            width:"30%",
                            height:"auto",
                            // filter:`drop-shadow(10px -5px 100px ${theme.palette.secondary.main}) drop-shadow(-10px -5px 5px ${theme.palette.text.primary})`
                        }}
                        alt='My picture'
                    />
                </Box>
            </Grid>
            <Grid xs={12} sm={12} md={6}  >
                <Box sx={{textAlign:{xs:"center",sm:"center",md:"left"}}} data-aos="fade-up" data-aos-duration="2000">
                    <Typography variant='h7' sx={{color:'shade.light',}} >
                        I’m a full stack developer who blends creativity with technology to build impactful solutions.
                    </Typography>
                </Box>
                
                <TableContainer component={Paper} sx={{backgroundColor:"transparent",border:"none",boxShadow:"none"}}>
                    <Table sx={{margin:"25px 0px",width:"auto"}} data-aos="fade-up" data-aos-duration="2000">
                        <TableBody>
                            {
                                details.map((obj)=>
                                {
                                    return(
                                        <TableRow
                                            key={obj}
                                        >
                                            <TableCell  
                                                align="left" 
                                                sx={{
                                                    color:'text.primary',
                                                    fontWeight:"bold",
                                                    border:"none",
                                                    width:"150px",
                                                    paddingLeft:"0px" ,
                                                }}
                                            >
                                                    {obj.property}
                                            </TableCell>
                                            <TableCell 
                                                align="left"
                                                sx={{
                                                    color:'shade.light',
                                                    border:"none",
                                                    padding: "10px 0px 10px 0px",

                                                }}
                                                
                                            >
                                                :{obj.value}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                    
                <Btn2 
                    data-aos="fade-up" data-aos-duration="2000"
                    onClick={handleDownload}
                    sx={{
                        fontSize:{xs:"0.8rem",sm:"1rem",md:"1.08rem"},
                        padding:{xs:"5px 20px",sm:"5px 25px",md:"5px 35px"},
                        '&:after':{
                        height:"100%"
                        },
                        '&:hover:after':{
                            height:"0%"
                        } 
                    }}>
                    {downloadStatus}
                    {downloadStatus=="Downloaded"? <FileDownloadDoneIcon/>:<DownloadIcon/>}
                </Btn2>
                <Snackbar open={openStatus} autoHideDuration={6000} onClose={closeStatus}>
                    <Alert
                        onClose={closeStatus}
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {statusMessage}
                    </Alert>
                </Snackbar>
            </Grid>
        </Grid>
    </Box>
  )
}

export default About